/**
 * @generated SignedSource<<40d8d964b293615b13060cf96a1c4fa0>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scheduleTemplatePeriod"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "scheduleTemplatePeriod"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduleTemplateId",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleTemplatePeriodModalQuery",
            "selections": [
                {
                    "alias": "period",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "type": "ScheduleTemplatePeriod",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleTemplatePeriodModalQuery",
            "selections": [
                {
                    "alias": "period",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "type": "ScheduleTemplatePeriod",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "ff9e06a7bfb6486e4322ca379bb8935e",
            "id": null,
            "metadata": {},
            "name": "EditScheduleTemplatePeriodModalQuery",
            "operationKind": "query",
            "text": "query EditScheduleTemplatePeriodModalQuery(\n  $scheduleTemplatePeriod: ID!\n) {\n  period: node(id: $scheduleTemplatePeriod) {\n    __typename\n    ... on ScheduleTemplatePeriod {\n      id\n      name\n      scheduleTemplateId\n    }\n    id\n  }\n}\n"
        }
    };
})();
node.hash = "41450adc8297718c7caa8b8e59617259";
export default node;
